import { Component, OnInit, Inject } from '@angular/core';
import {MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgForm } from '@angular/forms';
import { AuthService } from 'src/app/services/auth.service';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-add-page-title',
  templateUrl: './add-page-title.component.html',
  styleUrls: ['./add-page-title.component.css']
})
export class AddPageTitleComponent implements OnInit {
  selectedCat: any[] = [];
  categories: any[] = [];
  allSelectedCat: any[] = [];
  site: any = {};

  constructor(
    public dialogRef: MatDialogRef<AddPageTitleComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private authService: AuthService, private httpClient: HttpClient
  ) { }

  ngOnInit() {
    let user = this.authService.getLoggedUser()
    this.site.siteId = user.siteId
    this.GetComponents()
  }

  GetComponents() {
    this.httpClient.get('/Components/GetAllComponents').subscribe((res: any) => {
      for (let i = 0; i < res.length; i++) {
        const element = res[i].category;
        this.categories.push({ id: element.id, label: element.name })
      }
      if (this.allSelectedCat.length > 0) {
        for (let i = 0; i < this.categories.length; i++) {
          const orgCat = this.categories[i];
          for (let j = 0; j < this.allSelectedCat.length; j++) {
            const selectCat = this.allSelectedCat[j];
            if (orgCat.label == selectCat.label) {
              this.selectedCat.push({ id: orgCat.id, label: orgCat.label })
            }
          }

        }
      }
    });

  }
  addCat(name) {
    return { id: 0, label: name };
  }
  saveTitle(form: NgForm) {
    if (form.invalid) {
      Object.keys(form.controls).forEach(feild => {
        form.controls[feild].markAsTouched();
      });
      return;
    }
    if (!this.data.category)
      this.dialogRef.close(form.value.Title);
    else
      this.dialogRef.close({ name: form.value.Title, category: form.value.selectedCat });
  }

  close() {
    this.dialogRef.close(false);
  }

}
